module.exports = __webpack_public_path__ + "img/Profil_CS-Multiliner_Combi.2e496c34.jpg";